import { IFilterListOption } from '@app/lib/interfaces';

export const CANDIDATE_STATE_KEY = 'candidates';

export const D_NONE = 'd-none';

export const DISMISSED = 'off-study';

export const INELIGIBLE = 'ineligible';

export const IN_PROGRESS = 'screening';

export const STATUS_DISPLAY_VALUES = ​{
  candidate: 'New Candidate',
  eligible: 'Eligible',
  'follow-up': 'Follow Up',
  ineligible: 'Ineligible',
  'not-registered': 'Not Registered',
  'off-study': 'Dismissed',
  'on-study': 'On Clinical Trial',
  'on-study-intervention': 'On Clinical Trial Intervention',
  'on-study-observation': 'On Clinical Trial Observation',
  'pending-on-study': 'Registered',
  'potential-candidate': 'Potential Candidate',
  screening: 'In Progress',
  withdrawn: 'Withdrawn',
};

export const STATUS_DROPDOWN_OPTIONS = ['candidate', 'screening', 'pending-on-study', 'withdrawn', 'off-study'];

// Filter Options listed in same order as columns in Candidate List table for consistency
export const CANDIDATES_FILTER_OPTIONS: IFilterListOption[] = [
  {
    displayName: 'Status',
    paramName: 'status',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'Date Added',
    paramName: 'dateAdded',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'Completeness',
    paramName: 'completeness',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'Gender',
    paramName: 'gender',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'DOB',
    paramName: 'dob',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'Home Phone',
    paramName: 'homePhone',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'Mobile Phone',
    paramName: 'mobilePhone',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'Address',
    paramName: 'address',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'Email',
    paramName: 'email',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'Race',
    paramName: 'race',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'Ethnicity',
    paramName: 'ethnicity',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'LPID',
    paramName: 'lpib',
    toggleable: true,
    toggled: true
  },
  {
    displayName: 'MRN',
    paramName: 'mrn',
    toggleable: true,
    toggled: true
  },
];
